import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { FloatingContainerTitle } from '../casting-styled.component'
import { I18nService } from '../../../../services/utils/i18n.service'
import { StyledDayPicker, getDayPickerDateLocale } from '../../../shared/styled-day-picker.component'
import { moment } from '../../../../services/utils/moment.service'

type Props = StoreProps & {
  initialMonth: Date
  fromMonth: Date
  startDate: Date
  isStartDayDisabled: (date: Date) => boolean
}
const i18nScoped = new I18nService(require('./casting-start-date-lodging.component.yml'))

export default function CastingStartDateLodgingComponent ({ store, data: { slots }, initialMonth, fromMonth, startDate, isStartDayDisabled }: Props) {
  const setStartDate = React.useCallback((startDate: Date) => {
    // In this mode (automatic casting based on the lodging's ical), the customer supply partial slots information, with:
    // - a duration, that will be reused for all planned events
    // - a start date, starting at each the lodgig bookings are considered.
    //
    // At the time of writing this comment, a single slot is supported, but it may change in a future version (multiple events per lodging booking).
    store.setSlots([{ ...slots[0], start_date: moment(startDate).format('YYYY-MM-DD'), allowed_patterns: [] }])
    store.nextFocus()
  }, [slots, store])

  return <>
    <FloatingContainerTitle>{ i18nScoped.t('automatic_start_date') }</FloatingContainerTitle>

    <StyledDayPicker
      mode='single'
      defaultMonth={ initialMonth }
      startMonth={ fromMonth }
      locale={ getDayPickerDateLocale() }
      selected={ startDate }
      disabled={ isStartDayDisabled }
      onSelect={ setStartDate } />
  </>
}